import {
    Card,
    Typography,
    FormControl,
    FormControlLabel,
    Grid,
    TextField,
    Select,
    InputLabel,
    MenuItem,
    Button,
    Paper,
    FormGroup,
    Checkbox,
    Box,
    Stack,
    Chip,
    IconButton,
    Tooltip,
    Menu,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { Visibility, MailOutline as MailOutlineIcon, InfoOutlined, MoreVert } from "@mui/icons-material";
import { useState, useMemo, useRef, useLayoutEffect, useEffect } from 'react';
import { getData } from '../../../../../services/library';
import { validarCuit, validarTelefono } from '../validaciones';
import CorreosPorAreaSection from '../CorreosPorAreaSection';
import UnidadesNegocioSection from '../UnidadesNegocioSection';
import { esFlagActivo, normalizarUnidadesNegocio, tieneEmpresaSeleccionada } from '../unidadesNegocioUtils';
import {
    readonlyContainerSx,
    readonlyTextFieldSx,
    readonlyTextFieldVariant,
} from '../../readonlyFieldStyles';

export default function DataProveedores(props) {
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
    const refContactoActividad = useRef(null);
    const [alturaContactoActividad, setAlturaContactoActividad] = useState(null);

    //estados de lo que obtengo del backend
    const [tipoMoneda, settipoMoneda] = useState([]);
    const [paises, setPaises] = useState([]);
    // console.log("paisses", paises);

    const [actividades, setActividades] = useState([]);
    const [condiciones, setcondiciones] = useState([]);
    const [convenios, setconvenios] = useState([]);
    const [bancos, setBancos] = useState([]);
    const [errorEmail, setErrorEmail] = useState(false);
    let readOnly = (props?.editar === 1 ? false : true);
    const soloDetalle = Boolean(props.soloDetalle);
    const mostrarValidaciones = !readOnly;
    const documentosLista = Array.isArray(props?.documentos) ? props.documentos : [];
    const fieldVariant = readOnly ? readonlyTextFieldVariant : "outlined";
    const fieldSx = readOnly ? readonlyTextFieldSx : { bgcolor: "#fff", borderRadius: 2 };
    const monedaLabel =
        tipoMoneda?.find(
            (m) => Number(m.idtipo_moneda_afip) === Number(props.datos?.id_moneda)
        )?.moneda ||
        props.datos?.moneda ||
        "";
    const paisLabel =
        props.datos?.pais ||
        paises?.find((p) => Number(p.id_pais) === Number(props.datos?.id_pais))?.pais ||
        "";
    const condicionLabel =
        props.datos?.condicion ||
        condiciones?.find(
            (c) => Number(c.id) === Number(props.datos?.id_condicioniva)
        )?.descripcion ||
        "";
    const convenioLabel =
        props.datos?.convenio ||
        convenios?.find((c) => Number(c.id_convenio) === Number(props.datos?.id_convenio))?.convenio ||
        "";
    const bancoLabel =
        props.datos?.banco ||
        bancos?.find((b) => Number(b.id) === Number(props.datos?.id_banco))?.nombre ||
        "";
    //si viene de editar es 1, si viene de revisar es 0
    const docTipo1 = documentosLista.find(a => Number(a.id_tipoadjunto) === 1);
    const docTipo2 = documentosLista.find(a => Number(a.id_tipoadjunto) === 2);
    const docTipo5 = documentosLista.find(a => a.id_tipoadjunto === 5); // CM01
    const docTipo3 = documentosLista.find(a => a.id_tipoadjunto === 3); //CM05
    const docTipo11 = documentosLista.find(a => Number(a.id_tipoadjunto) === 11);
    const docConvenio5 = docTipo5;
    const docConvenio3 = docTipo3;
    const [Leyenda, setLeyenda] = useState("");
    const [ErrorTelefono, setErrorTelefono] = useState(false);
    const [LeyendaTelefono, setLeyendaTelefono] = useState("");
    const [ErrorTitulo, setErrorTitulo] = useState(false);
    const [error, setError] = useState(false);
    const [LeyendaAutogas, setLeyendaAutogas] = useState("");

    const [errorCBU, setErrorCBU] = useState(false);
    const [mensajeError, setMensajeError] = useState("");
    const [menuCorreosAnchor, setMenuCorreosAnchor] = useState(null);
    const [menuCorreosLista, setMenuCorreosLista] = useState([]);
    /** Clave `id_area::nombre` → fila de correos desplegada (muestra todos los chips) */
    const [correosPorAreaExpandido, setCorreosPorAreaExpandido] = useState({});
    const [areasCatalogo, setAreasCatalogo] = useState([]);

    useEffect(() => {
        if (!readOnly) return;
        getData("/proveedores/areas", (data) => {
            setAreasCatalogo(Array.isArray(data) ? data : []);
        });
    }, [readOnly]);

    useEffect(() => {
        if (mostrarValidaciones) return;
        setErrorTitulo(false);
        setLeyenda("");
        setErrorTelefono(false);
        setLeyendaTelefono("");
        setErrorEmail(false);
        setError(false);
        setLeyendaAutogas("");
        setErrorCBU(false);
        setMensajeError("");
    }, [mostrarValidaciones]);

    const resolverNombreArea = (id_area, nombre_area) => {
        if (nombre_area) return nombre_area;
        const area = areasCatalogo.find((a) => Number(a.id) === Number(id_area));
        return area?.nombre || (id_area != null ? `Área ${id_area}` : "Sin área");
    };

    const correosPorAreaFuente = useMemo(() => {
        let items = [];
        if (Array.isArray(props.correosPorArea) && props.correosPorArea.length > 0) {
            items = props.correosPorArea;
        } else if (
            Array.isArray(props.datos?.correos_por_area) &&
            props.datos.correos_por_area.length > 0
        ) {
            items = props.datos.correos_por_area;
        }
        if (items.length === 0) return [];
        return items.map((row) => {
            if (!row) return row;
            const nombre = resolverNombreArea(row.id_area, row.nombre_area);
            return nombre && nombre !== row.nombre_area
                ? { ...row, nombre_area: nombre }
                : row;
        });
    }, [props.correosPorArea, props.datos?.correos_por_area, areasCatalogo]);

    const correosAgrupadosPorArea = useMemo(() => {
        const items = correosPorAreaFuente;
        if (!Array.isArray(items) || items.length === 0) return [];
        const map = new Map();
        items.forEach((row) => {
            if (!row) return;
            const key =
                row.id_area != null && row.id_area !== ""
                    ? `id:${row.id_area}`
                    : `nom:${row.nombre_area || "_"}`;
            const nombre = resolverNombreArea(row.id_area, row.nombre_area);
            if (!map.has(key)) {
                map.set(key, { id_area: row.id_area, nombre_area: nombre, filas: [] });
            }
            map.get(key).filas.push(row);
        });
        return Array.from(map.values());
    }, [correosPorAreaFuente, areasCatalogo]);

    const firmaCorreosPorArea = useMemo(
        () => JSON.stringify(correosPorAreaFuente),
        [correosPorAreaFuente]
    );

    const MAX_CHIPS_VISIBLES = 2;

    const aceptaEcheq = props.datos?.acepta_echeq ?? props.data?.acepta_echeq;
    const otrasUnidadesNegocio =
        props.datos?.otras_unidades_negocio ?? props.data?.otras_unidades_negocio;
    const unidadesNegocio = useMemo(
        () =>
            normalizarUnidadesNegocio(
                props.datos?.unidades_negocio ?? props.data?.unidades_negocio
            ),
        [props.datos?.unidades_negocio, props.data?.unidades_negocio]
    );

    useLayoutEffect(() => {
        setCorreosPorAreaExpandido({});
    }, [props.datos?.nro_cuit, firmaCorreosPorArea]);

    useLayoutEffect(() => {
        if (!isMdUp || typeof ResizeObserver === "undefined") {
            setAlturaContactoActividad(null);
            return undefined;
        }
        const el = refContactoActividad.current;
        if (!el) return undefined;

        const actualizar = () => {
            const h = Math.round(el.getBoundingClientRect().height);
            if (h > 0) setAlturaContactoActividad(h);
        };

        actualizar();
        const ro = new ResizeObserver(actualizar);
        ro.observe(el);
        return () => ro.disconnect();
    }, [isMdUp, props.step, readOnly, correosAgrupadosPorArea.length]);

    useEffect(() => {
        getData("/tipo_moneda_afip", settipoMoneda);
    }, []);

    useEffect(() => {
        if (props.step !== 0 && !readOnly) return;

        getData("/paises", setPaises);
        getData("/bancos", setBancos);
        getData("/actividades", setActividades);
        getData("/condiciones_iva", setcondiciones);
        getData("/convenios", setconvenios);
    }, [props.step, readOnly]);


    const handleAlmacenarEmpresas = (id_empresa) => {
        const id = Number(id_empresa);
        if (!Number.isFinite(id) || !props?.setEmpresasSeleccionadas) return;
        props.setEmpresasSeleccionadas((prev) => {
            const actual = Array.isArray(prev) ? prev.map(Number).filter((n) => Number.isFinite(n)) : [];
            if (actual.includes(id)) {
                return actual.filter((item) => item !== id);
            }
            return [...actual, id];
        });
    };

    const handleToggleOtrasUnidades = (checked) => {
        if (readOnly || !props.setDatos) return;
        props.setDatos((prev) => ({
            ...prev,
            otras_unidades_negocio: checked ? 1 : 0,
        }));
    };

    const handleUnidadesChange = (next) => {
        if (readOnly || !props.setDatos) return;
        props.setDatos((prev) => ({
            ...prev,
            unidades_negocio: next,
            otras_unidades_negocio: 1,
        }));
    };

    const handleToggleAceptaEcheq = () => {
        if (readOnly || !props.setDatos) return;
        props.setDatos((prev) => ({
            ...prev,
            acepta_echeq: esFlagActivo(prev?.acepta_echeq) ? 0 : 1,
        }));
    };

    const validarEmail = (value) => {
        // Este regex prohibe puntos al inicio, puntos dobles y puntos al final del nombre
        const regex = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // Además de testear, verificamos que no termine en punto (algunos regex fallan ahi jajajajajajjajajaajjaja)
        return regex.test(value) && !value.endsWith('.');
    };

    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: 3,
                backgroundColor: "#f4f6f8",
                py: 1.5,
                border: "1px solid #e0e6ed",
                mb: readOnly ? 0 : 5,
                maxWidth: "100%",
                overflowX: "hidden",
                boxSizing: "border-box",
                ...(readOnly ? readonlyContainerSx : {}),
            }}
        >
            {/*Sección empresa */}
            <Card variant="outlined" sx={{ p: 1, borderRadius: 2, borderLeft: '5px solid #1F618D' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="CUIT"
                            name="nro_cuit"
                            type="text"
                            inputMode="numeric"
                            fullWidth
                            focused
                            size="small"
                            variant={fieldVariant}
                            sx={fieldSx}
                            value={props.datos?.nro_cuit || ""}
                            onChange={(e) => {
                                const val = e.target.value;

                                // bloqueo físico
                                if (val.length <= 11) {
                                    props.handleAlmacenarDatos(e);
                                }
                            }}
                            onBlur={mostrarValidaciones ? (e) => {
                                const { ok, mensaje } = validarCuit(e.target.value);

                                setErrorTitulo(!ok);
                                setLeyenda(mensaje);
                            } : undefined}
                            inputProps={{
                                readOnly,
                                min: 0,
                                onKeyDown: (e) =>
                                    ["e", "E", "+", ".", "-"].includes(e.key) && e.preventDefault(),
                            }}
                            helperText={mostrarValidaciones ? Leyenda : undefined}
                            error={mostrarValidaciones && ErrorTitulo}
                        />

                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            value={props.datos?.razon_social || ""}
                            name="razon_social"
                            inputProps={{ readOnly: readOnly }}
                            onChange={props?.handleAlmacenarDatos}
                            label="Razón Social"
                            fullWidth
                            focused
                            autoComplete='off'
                            variant={fieldVariant}
                            size="small"
                            sx={fieldSx}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="Nombre Fantasía"
                            fullWidth
                            focused
                            value={props.datos?.nombre_fantasia}
                            name="nombre_fantasia"
                            inputProps={{ readOnly: readOnly }}
                            onChange={props?.handleAlmacenarDatos}
                            variant={fieldVariant}
                            size="small"
                            sx={fieldSx}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="Direccion Fiscal"
                            fullWidth
                            focused
                            value={props.datos?.direccion}
                            name="direccion"
                            inputProps={{ readOnly: readOnly }}
                            onChange={props?.handleAlmacenarDatos}
                            variant={fieldVariant}
                            size="small"
                            sx={fieldSx}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        {readOnly ?
                            (
                                <TextField
                                    label="Pais"
                                    fullWidth
                                    focused
                                    value={paisLabel}
                                    inputProps={{ readOnly: true }}
                                    variant={fieldVariant}
                                    size="small"
                                    sx={fieldSx}
                                />
                            ) :
                            <FormControl fullWidth size="small" focused >
                                <InputLabel>País</InputLabel>
                                <Select
                                    label="País"
                                    value={props.datos.id_pais || ""}
                                    onChange={props?.handleAlmacenarDatos}
                                    name="id_pais">
                                    {paises && paises.map((el) =>
                                        <MenuItem key={el.id_pais} value={el.id_pais}>
                                            {el.pais}
                                        </MenuItem>)}
                                </Select>

                            </FormControl>
                        }

                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        {soloDetalle ? (
                            <TextField
                                label="Moneda"
                                fullWidth
                                focused
                                value={monedaLabel}
                                inputProps={{ readOnly: true }}
                                variant={fieldVariant}
                                size="small"
                                sx={fieldSx}
                            />
                        ) : (
                            <FormControl fullWidth size="small" focused>
                                <InputLabel id="select-label">Moneda</InputLabel>
                                <Select
                                    labelId="select-label"
                                    value={props.datos.id_moneda || ""}
                                    label="Moneda"
                                    onChange={props?.handleAlmacenarDatos}
                                    fullWidth
                                    name="id_moneda"
                                >
                                    {tipoMoneda && tipoMoneda?.map((elemento) =>
                                        <MenuItem key={elemento.idtipo_moneda_afip} value={elemento.idtipo_moneda_afip}>
                                            {elemento.moneda}
                                        </MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="Sisven Italgas"
                            fullWidth
                            name="sisven_id"
                            focused
                            type='text'
                            value={props.datos?.sisven_id}
                            onChange={soloDetalle ? undefined : (e) => {
                                const val = e.target.value;

                                if (!/^\d*$/.test(val)) return;
                                if (val.length > 7) return;

                                props.handleAlmacenarDatos(e);
                            }}
                            inputProps={{
                                readOnly: soloDetalle,
                                inputMode: "numeric",
                                maxLength: 7,
                                onKeyDown: (e) =>
                                    ["e", "E", "+", "-", ".", ","].includes(e.key) &&
                                    e.preventDefault(),
                            }}
                            error={
                                mostrarValidaciones &&
                                props.datos?.sisven_id &&
                                props.datos.sisven_id.length < 2
                            }
                            helperText={
                                mostrarValidaciones &&
                                props.datos?.sisven_id &&
                                props.datos.sisven_id.length < 2
                                    ? "Debe tener al menos 2 dígitos"
                                    : " "
                            }
                            variant={fieldVariant}
                            size="small"
                            sx={fieldSx}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            label="Sisven Natural Gas"
                            name="autogas_id"
                            fullWidth
                            focused
                            size="small"
                            type="text"
                            value={props.datos.autogas_id ?? ""}
                            onChange={soloDetalle ? undefined : (e) => {
                                const val = e.target.value;

                                if (!/^\d*$/.test(val)) return;
                                if (val.length > 7) return;

                                props.handleAlmacenarDatos(e);
                            }}
                            onBlur={mostrarValidaciones ? (e) => {
                                const val = e.target.value;

                                if (val && val.length < 2) {
                                    setError(true);
                                    setLeyendaAutogas("Debe tener al menos 2 dígitos");
                                } else {
                                    setError(false);
                                    setLeyendaAutogas("");
                                }
                            } : undefined}
                            inputProps={{
                                readOnly: soloDetalle,
                                inputMode: "numeric",
                                maxLength: 7,
                                onKeyDown: (e) =>
                                    ["e", "E", "+", "-", ".", ","].includes(e.key) &&
                                    e.preventDefault(),
                            }}
                            error={mostrarValidaciones && error}
                            helperText={mostrarValidaciones ? LeyendaAutogas : undefined}
                            variant={fieldVariant}
                            size="small"
                            sx={fieldSx} />
                    </Grid>
                </Grid>

                <Grid container spacing={2} alignItems="center">
                    {/* Título */}
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography
                            variant="button"
                            sx={{
                                fontWeight: 600,
                                fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                ml: 2
                            }}
                        >
                            EMPRESA A LA QUE FACTURA
                        </Typography>
                    </Grid>

                    {/* Checkboxes */}
                    <Grid item xs={12} sm={6} md={6}>
                        <FormGroup
                            sx={{
                                display: "grid",
                                gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
                                gap: 1, p: 1,
                            }}
                        >


                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        disabled={readOnly}
                                        checked={tieneEmpresaSeleccionada(props?.empresasSeleccionadas, 4)}
                                        onChange={() => handleAlmacenarEmpresas(4)}
                                    />
                                }
                                label={<Typography sx={{ fontSize: "0.85rem" }}>Italgas</Typography>}
                            />

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        disabled={readOnly}
                                        checked={tieneEmpresaSeleccionada(props?.empresasSeleccionadas, 2)}
                                        onChange={() => handleAlmacenarEmpresas(2)}
                                    />
                                }
                                label={<Typography sx={{ fontSize: "0.85rem" }}>Natural gas</Typography>}
                            />
                        </FormGroup>
                    </Grid>
                </Grid>

                <UnidadesNegocioSection
                    otrasUnidadesNegocio={otrasUnidadesNegocio}
                    unidades={unidadesNegocio}
                    paises={paises}
                    disabled={readOnly}
                    onOtrasChange={handleToggleOtrasUnidades}
                    onUnidadesChange={handleUnidadesChange}
                />

            </Card>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: readOnly
                        ? { xs: "1fr", md: "minmax(0, 7fr) minmax(0, 5fr)" }
                        : "1fr",
                    gap: 1,
                    width: "100%",
                    alignItems: "start",
                    boxSizing: "border-box",
                }}
            >
                    <Box
                        ref={refContactoActividad}
                        sx={{
                            minWidth: 0,
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns: readOnly
                                ? "1fr"
                                : { xs: "1fr", md: "1fr 1fr" },
                            gap: 1,
                        }}
                    >
                        <Card variant="outlined" sx={{ p: 2, borderRadius: 2, borderLeft: "5px solid #1F618D" }}>
                            <Grid container sx={{ mb: 1.5, alignItems: "center" }}>
                                <Typography variant="button" sx={{ fontWeight: 700, color: "#1F618D" }}>
                                    Contacto
                                </Typography>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={3}>
                                    <TextField
                                        label="Teléfono"
                                        name="telefono"
                                        focused
                                        fullWidth
                                        size="small"
                                        value={props.datos?.telefono || ""}
                                        onChange={(e) => {
                                            const val = e.target.value;

                                            if (val.length <= 11) {
                                                props.handleAlmacenarDatos(e);
                                            }
                                        }}
                                        onBlur={mostrarValidaciones ? (e) => {
                                            const { ok, mensaje } = validarTelefono(e.target.value);
                                            setErrorTelefono(!ok);
                                            setLeyendaTelefono(mensaje);
                                        } : undefined}
                                        inputProps={{
                                            readOnly,
                                            min: 6,
                                            onKeyDown: (e) =>
                                                ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault(),
                                        }}
                                        helperText={mostrarValidaciones ? LeyendaTelefono : undefined}
                                        error={mostrarValidaciones && ErrorTelefono}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <TextField
                                        inputProps={{ readOnly: readOnly }}
                                        onChange={mostrarValidaciones ? (e) => {
                                            props?.handleAlmacenarDatos(e);
                                            const isInvalid = !validarEmail(e.target.value) && e.target.value !== "";
                                            setErrorEmail(isInvalid);
                                        } : undefined}
                                        autoComplete="off"
                                        label="Correo electrónico"
                                        fullWidth
                                        focused
                                        variant={fieldVariant}
                                        size="small"
                                        sx={fieldSx}
                                        name="email"
                                        value={props.datos?.email}
                                        error={mostrarValidaciones && errorEmail}
                                        helperText={mostrarValidaciones && errorEmail && "Formato de correo inválido"}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        inputProps={{ readOnly: readOnly }}
                                        onChange={props?.handleAlmacenarDatos}
                                        autoComplete="off"
                                        label="Nombre de contacto"
                                        fullWidth
                                        variant={fieldVariant}
                                        focused
                                        size="small"
                                        sx={fieldSx}
                                        name="nombre_contacto"
                                        value={props.datos?.nombre_contacto}
                                    />
                                </Grid>
                            </Grid>
                        </Card>

                        <Card variant="outlined" sx={{ p: 2, borderRadius: 2, borderLeft: "5px solid #1F618D" }}>
                            <Grid container sx={{ mb: 1.5, alignItems: "center" }}>
                                <Typography variant="button" sx={{ fontWeight: 600, color: "#1F618D" }}>
                                    Actividad
                                </Typography>
                            </Grid>
                            <Grid container spacing={2}>
                                {readOnly ? (
                                    <>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                inputProps={{ readOnly: true }}
                                                autoComplete="off"
                                                label="Actividad Principal"
                                                fullWidth
                                                focused
                                                variant={fieldVariant}
                                                size="small"
                                                sx={fieldSx}
                                                value={props.data.actividad_principal ?? "No hay registro"}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Actividad Secundaria"
                                                inputProps={{ readOnly: true }}
                                                autoComplete="off"
                                                fullWidth
                                                focused
                                                variant={fieldVariant}
                                                size="small"
                                                sx={fieldSx}
                                                value={props.data?.actividad_secundaria ?? "No hay registro"}
                                            />
                                        </Grid>
                                    </>
                                ) : (
                                    <>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth size="small" focused>
                                                <InputLabel>Principal</InputLabel>
                                                <Select
                                                    label="Principal"
                                                    name="id_actividadprincipal"
                                                    value={props.datos?.id_actividadprincipal || ""}
                                                    onChange={props?.handleAlmacenarDatos}
                                                >
                                                    {actividades &&
                                                        actividades.map((el) => (
                                                            <MenuItem key={el.id_actividad} value={el.id_actividad}>
                                                                {el.actividad}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl fullWidth size="small" focused>
                                                <InputLabel>Secundaria</InputLabel>
                                                <Select
                                                    label="Secundaria"
                                                    name="id_actividadsecundaria"
                                                    value={props.datos?.id_actividadsecundaria || ""}
                                                    onChange={props?.handleAlmacenarDatos}
                                                >
                                                    {actividades &&
                                                        actividades.map((el) => (
                                                            <MenuItem
                                                                key={el.id_actividad}
                                                                value={el.id_actividad}
                                                                disabled={props.datos?.id_actividadprincipal === el.id_actividad}
                                                            >
                                                                {el.actividad}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </Card>
                    </Box>

                    {!readOnly && props.setCorreosPorArea ? (
                        <CorreosPorAreaSection
                            filas={props.correosPorArea ?? []}
                            onFilasChange={props.setCorreosPorArea}
                        />
                    ) : (
                    <Card
                        variant="outlined"
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            borderLeft: "5px solid #1F618D",
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            minHeight: 0,
                            minWidth: 0,
                            overflow: "hidden",
                            boxSizing: "border-box",
                            ...(readOnly && isMdUp && alturaContactoActividad != null
                                ? { maxHeight: alturaContactoActividad }
                                : {}),
                        }}
                    >
                        <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            spacing={0.5}
                            sx={{ mb: 1.5, minWidth: 0, width: "100%" }}
                        >
                            <Stack
                                direction="row"
                                alignItems="center"
                                spacing={0.75}
                                sx={{ minWidth: 0, flex: 1, overflow: "hidden" }}
                            >
                                <MailOutlineIcon sx={{ color: "#1F618D", fontSize: 22, flexShrink: 0 }} />
                                <Typography
                                    variant="button"
                                    sx={{
                                        fontWeight: 700,
                                        color: "#1F618D",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        minWidth: 0,
                                    }}
                                >
                                    CORREOS POR ÁREA
                                </Typography>
                            </Stack>
                            <Tooltip
                                title="Correos informados por el proveedor para cada área de la empresa. Solo lectura en esta etapa."
                                arrow
                                placement="left"
                            >
                                <IconButton
                                    size="small"
                                    aria-label="información correos por área"
                                    sx={{ color: "text.secondary", flexShrink: 0 }}
                                >
                                    <InfoOutlined fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Stack>

                        <Box
                            sx={{
                                flex: 1,
                                width: "100%",
                                minHeight: { xs: 120, md: 0 },
                                minWidth: 0,
                                overflow: "auto",
                                overflowX: "hidden",
                                bgcolor: "#fafbfc",
                                borderRadius: 1,
                                border: "1px solid #e8ecf0",
                                boxSizing: "border-box",
                            }}
                        >
                            {correosAgrupadosPorArea.length === 0 ? (
                                <Typography variant="body2" color="text.secondary" sx={{ p: 1.5 }}>
                                    No hay correos registrados por área.
                                </Typography>
                            ) : (
                                correosAgrupadosPorArea.map((grupo) => {
                                    const filas = grupo.filas || [];
                                    const grupoKey = `${grupo.id_area ?? ""}::${grupo.nombre_area ?? ""}`;
                                    const expandido = Boolean(correosPorAreaExpandido[grupoKey]);
                                    const hayMas = filas.length > MAX_CHIPS_VISIBLES;
                                    const filasChips = expandido ? filas : filas.slice(0, MAX_CHIPS_VISIBLES);
                                    const ocultos = expandido ? 0 : Math.max(0, filas.length - MAX_CHIPS_VISIBLES);

                                    const toggleExpandirArea = () => {
                                        setCorreosPorAreaExpandido((prev) => ({
                                            ...prev,
                                            [grupoKey]: !prev[grupoKey],
                                        }));
                                    };

                                    return (
                                        <Stack
                                            key={`${grupo.id_area ?? ""}-${grupo.nombre_area}`}
                                            direction="row"
                                            alignItems="flex-start"
                                            spacing={0.5}
                                            sx={{
                                                py: 1.1,
                                                px: 1,
                                                width: "100%",
                                                maxWidth: "100%",
                                                minWidth: 0,
                                                boxSizing: "border-box",
                                                borderBottom: "1px solid",
                                                borderColor: "divider",
                                                "&:last-of-type": { borderBottom: "none" },
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontWeight: 700,
                                                    color: "#1a237e",
                                                    flex: "0 1 32%",
                                                    minWidth: 0,
                                                    maxWidth: "38%",
                                                    fontSize: "0.8rem",
                                                    lineHeight: 1.35,
                                                    pr: 0.5,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 3,
                                                    WebkitBoxOrient: "vertical",
                                                    wordBreak: "break-word",
                                                }}
                                                title={grupo.nombre_area}
                                            >
                                                {grupo.nombre_area}
                                            </Typography>
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    minWidth: 0,
                                                    maxWidth: "100%",
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    gap: 0.6,
                                                    alignItems: "center",
                                                    alignContent: "flex-start",
                                                }}
                                            >
                                                {filasChips.map((fila, idx) => (
                                                    <Chip
                                                        key={fila.id != null ? String(fila.id) : `${fila.correo}-${idx}`}
                                                        label={fila.correo || "—"}
                                                        size="small"
                                                        title={fila.correo || ""}
                                                        sx={{
                                                            bgcolor: "#e8ecf2",
                                                            color: "text.primary",
                                                            fontWeight: 500,
                                                            fontSize: "0.72rem",
                                                            height: "auto",
                                                            minHeight: 26,
                                                            maxWidth: "100%",
                                                            "& .MuiChip-label": {
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "normal",
                                                                wordBreak: "break-all",
                                                                display: "block",
                                                                py: 0.25,
                                                            },
                                                        }}
                                                    />
                                                ))}
                                                {!expandido && ocultos > 0 ? (
                                                    <Tooltip title={`Ver ${ocultos} correo${ocultos === 1 ? "" : "s"} más`}>
                                                        <Chip
                                                            label={`+${ocultos}`}
                                                            size="small"
                                                            variant="outlined"
                                                            onClick={toggleExpandirArea}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    e.preventDefault();
                                                                    toggleExpandirArea();
                                                                }
                                                            }}
                                                            tabIndex={0}
                                                            role="button"
                                                            sx={{
                                                                fontWeight: 700,
                                                                height: 26,
                                                                fontSize: "0.72rem",
                                                                flexShrink: 0,
                                                                cursor: "pointer",
                                                                "&:hover": { bgcolor: "action.hover" },
                                                            }}
                                                        />
                                                    </Tooltip>
                                                ) : null}
                                                {expandido && hayMas ? (
                                                    <Tooltip title="Mostrar solo los primeros correos">
                                                        <Chip
                                                            label="Ocultar"
                                                            size="small"
                                                            variant="outlined"
                                                            onClick={toggleExpandirArea}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" || e.key === " ") {
                                                                    e.preventDefault();
                                                                    toggleExpandirArea();
                                                                }
                                                            }}
                                                            tabIndex={0}
                                                            role="button"
                                                            sx={{
                                                                fontWeight: 600,
                                                                height: 26,
                                                                fontSize: "0.72rem",
                                                                flexShrink: 0,
                                                                cursor: "pointer",
                                                                "&:hover": { bgcolor: "action.hover" },
                                                            }}
                                                        />
                                                    </Tooltip>
                                                ) : null}
                                            </Box>
                                            <Tooltip title="Opciones">
                                                <IconButton
                                                    size="small"
                                                    aria-label={`opciones ${grupo.nombre_area}`}
                                                    onClick={(e) => {
                                                        setMenuCorreosAnchor(e.currentTarget);
                                                        setMenuCorreosLista(
                                                            filas.map((f) => f.correo).filter(Boolean)
                                                        );
                                                    }}
                                                    sx={{ mt: -0.25, flexShrink: 0 }}
                                                >
                                                    <MoreVert fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </Stack>
                                    );
                                })
                            )}
                        </Box>
                    </Card>
                    )}
            </Box>

            {readOnly ? (
            <Menu
                anchorEl={menuCorreosAnchor}
                open={Boolean(menuCorreosAnchor)}
                onClose={() => {
                    setMenuCorreosAnchor(null);
                    setMenuCorreosLista([]);
                }}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <MenuItem
                    onClick={() => {
                        const texto = menuCorreosLista.join("; ");
                        if (texto && navigator.clipboard?.writeText) {
                            navigator.clipboard.writeText(texto);
                        }
                        setMenuCorreosAnchor(null);
                        setMenuCorreosLista([]);
                    }}
                    disabled={!menuCorreosLista.length}
                >
                    Copiar correos del área
                </MenuItem>
            </Menu>
            ) : null}

            {/*seccion documentacion */}

            <Card variant="outlined" sx={{ p: 2, borderRadius: 2, borderLeft: '5px solid #1F618D' }}>
                <Grid container sx={{ mb: 1.5, alignItems: 'center' }}>
                    <Typography variant="button" sx={{ fontWeight: 700, color: "#1F618D" }}>Documentación </Typography>
                </Grid>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    {readOnly ? (
                        <>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Responsable frente al IVA"
                                    fullWidth
                                    focused
                                    size="small"
                                    variant={fieldVariant}
                                    sx={fieldSx}
                                    value={condicionLabel}
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Condición IIBB"
                                    fullWidth
                                    focused
                                    size="small"
                                    variant={fieldVariant}
                                    sx={fieldSx}
                                    value={convenioLabel}
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Banco"
                                    focused
                                    fullWidth
                                    size="small"
                                    variant={fieldVariant}
                                    sx={fieldSx}
                                    value={bancoLabel}
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="CBU"
                                    fullWidth
                                    name="cbu"
                                    focused
                                    size="small"
                                    variant={fieldVariant}
                                    sx={fieldSx}
                                    value={props.datos?.cbu}
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                        </>
                    ) : (
                        <>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth focused size="small">
                                    <InputLabel>IVA</InputLabel>
                                    <Select
                                        label="IVA"
                                        name="id_condicioniva"
                                        value={props.datos.id_condicioniva || ""}
                                        onChange={props?.handleAlmacenarDatos}>
                                        {condiciones && condiciones.map((el) =>
                                            <MenuItem key={el.id} value={el.id}>
                                                {el.descripcion}
                                            </MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth focused size="small" >
                                    <InputLabel>Condición IIBB</InputLabel>
                                    <Select
                                        label="Condición IIBB"
                                        name="id_convenio"
                                        value={props?.datos.id_convenio || ""}
                                        onChange={props?.handleAlmacenarDatos}>
                                        {convenios && convenios.map((conv) =>
                                            <MenuItem key={conv.id_convenio} value={conv.id_convenio}>
                                                {conv.convenio}
                                            </MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth focused size="small" >
                                    <InputLabel>Banco</InputLabel>
                                    <Select
                                        label="Banco"
                                        name="id_banco"
                                        value={props.datos.id_banco || ""}
                                        onChange={props?.handleAlmacenarDatos}>
                                        {bancos && bancos.map((conv) =>
                                            <MenuItem key={conv.id} value={conv.id}>
                                                {conv.nombre}
                                            </MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="CBU"
                                    fullWidth
                                    size="small"
                                    focused
                                    name="cbu"
                                    value={props.datos?.cbu}
                                    helperText={mensajeError}
                                    error={errorCBU}
                                    onBlur={(e) => {
                                        const valor = e.target.value;

                                        if (!/^\d*$/.test(valor) || valor.length > 22) return;

                                        if (valor.length === 0) {
                                            setErrorCBU(false);
                                            setMensajeError("");
                                        } else if (valor.startsWith("000")) {
                                            setErrorCBU(true);
                                            setMensajeError("No se permiten CVU (cuentas virtuales)");
                                        } else if (valor.length < 22) {
                                            setErrorCBU(true);
                                            setMensajeError("El CBU debe tener exactamente 22 dígitos");
                                        } else {
                                            setErrorCBU(false);
                                            setMensajeError("");
                                        }
                                    }}
                                    onChange={props?.handleAlmacenarDatos}
                                />
                            </Grid>
                        </>
                    )}
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    disabled={readOnly}
                                    checked={esFlagActivo(aceptaEcheq)}
                                    onChange={handleToggleAceptaEcheq}
                                />
                            }
                            label={
                                <Typography sx={{ fontSize: "0.85rem", fontWeight: 600 }}>
                                    Acepta eCheq
                                </Typography>
                            }
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={props?.datos?.id_convenio === 1 ? 3 : 4}>
                        <Button
                            fullWidth
                            size='small'
                            variant="outlined"
                            startIcon={<Visibility />}
                            onClick={() => {
                                if (!docTipo1) {
                                    alert("No hay documento cargado");
                                    return;
                                }

                                readOnly ? props.ViewFiles(docTipo1.nombre, docTipo1.extension) : props.abrirGestorAdjunto(1, "Constancia Arca")
                            }}
                        >
                            Ver constancia ARCA
                        </Button>
                    </Grid>

                    {props?.datos?.id_convenio === 1 ? (
                        <>
                            <Grid item xs={12} sm={6} md={3} >
                                <Button
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    startIcon={<Visibility />}
                                    onClick={() => {
                                        if (!docConvenio5) {
                                            alert("No hay documento cargado");
                                            return;
                                        }
                                        readOnly ? props.ViewFiles(docConvenio5.nombre, docConvenio5.extension) : props.abrirGestorAdjunto(5, "CM01")
                                    }}
                                >
                                    ARCHIVO CM01
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} >
                                <Button
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    startIcon={<Visibility />}
                                    onClick={() => {
                                        if (!docConvenio3) {
                                            alert("No hay documento cargado");
                                            return;
                                        }

                                        readOnly ? props.ViewFiles(docConvenio3.nombre, docConvenio3.extension) : props.abrirGestorAdjunto(3, "CM05")
                                    }}
                                >
                                    ARCHIVO CM05
                                </Button>
                            </Grid>
                        </>
                    ) :
                        <Grid item xs={12} sm={6} md={4} >
                            <Button
                                fullWidth
                                size="small"
                                variant="outlined"
                                startIcon={<Visibility />}
                                onClick={() => {
                                    if (!docTipo2) {
                                        alert("No hay documento cargado");
                                        return;
                                    }
                                    readOnly ? props.ViewFiles(docTipo2.nombre, docTipo2.extension) : props.abrirGestorAdjunto(2, "Condición IIBB")
                                }}
                            >
                                CONDICIÓN IIBB
                            </Button>
                        </Grid>
                    }
                    <Grid item xs={12} sm={6} md={props?.datos?.id_convenio === 1 ? 3 : 4} >
                        <Button
                            size="small"
                            fullWidth
                            variant="outlined"
                            startIcon={<Visibility />}
                            onClick={() => {
                                if (!docTipo11) {
                                    alert("No hay documento cargado");
                                    return;
                                }
                                readOnly ? props.ViewFiles(docTipo11.nombre, docTipo11.extension) : props.abrirGestorAdjunto(11, "CONSTANCIA CBU")
                            }}
                        >
                            CONSTANCIA CBU
                        </Button>
                    </Grid>
                </Grid>
            </Card>
        </Paper >
    );
}